import { useSignerAppClient } from 'signer-app/context/signer-app-client';

export type ReadyParams = {
  tsmGuid: string;
  token?: string;
  triggerSms?: 0 | 1;
  smsAuthCode?: string;
  accessCode?: string;
};

export function useReady() {
  const client = useSignerAppClient();
  return async (p: ReadyParams) => {
    return client.signerApi.signerAppReadyRequest(
      p.tsmGuid,
      p.token,
      p.triggerSms,
      p.smsAuthCode,
      p.accessCode,
    );
  };
}
